import { Board } from 'chessboard/model/board/types';
import { Core } from 'chessboard/core/config/types';
import { createKeyedHighlight } from 'chessboard/plugins/highlights/model/create-keyed-highlight';
import { getLegacyThemeValues } from 'chessboard/config/legacy-themes';
import type { KeyedHighlight } from 'chessboard/plugins/highlights/config/types';

/**
 * Add the selection square to the highlights object on the event.
 * This object ultimately passes through the highlights arbitrage middleware
 * to determine whether or not it should be shown.
 */
export function getSelectionSquare(_event: Core.Event, context: Core.Context): KeyedHighlight[] {
  const { options, state } = context;

  if (!options || !options.highlightMoves) {
    return [];
  }

  const selectedSquare = state.get(Core.State.SelectedPiece) || state.get(Core.State.DraggingPiece);

  if (!selectedSquare) {
    return [];
  }

  const selectionHighlight = createKeyedHighlight({
    color:
      options.themeAssets?.board.config.highlightSquareHex ??
      getLegacyThemeValues(options.boardStyle)?.highlightColor ??
      Board.HighlightColors.Selected,
    opacity: options.highlightOpacity,
    square: selectedSquare,
    type: 'SelectionHiglight',
  });

  return [selectionHighlight];
}
